import {
  Notification,
  NotificationType,
  NotificationPriority,
  NotificationStatus,
  RelatedEntityType,
} from '../models/notification.model';

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 1,
    userId: 1,
    titleKey: 'notifications.new-maintenance-request',
    title: 'notifications.new-maintenance-request',
    messageKey: 'notifications.new-maintenance-request-message',
    message: 'notifications.new-maintenance-request-message',
    type: NotificationType.INFO,
    priority: NotificationPriority.MEDIUM,
    status: NotificationStatus.DELIVERED,
    isRead: false,
    createdDate: new Date('2024-01-15T10:30:00Z'),
    relatedEntityType: RelatedEntityType.REQUEST,
    relatedEntityId: 1,
    actionUrl: '/requests/1',
    actionTextKey: 'notifications.view-request',
    actionText: 'notifications.view-request',
    icon: 'wrench',
    color: '#4ECDC4',
  },
  {
    id: 2,
    userId: 2,
    titleKey: 'notifications.invoice-payment-reminder',
    title: 'notifications.invoice-payment-reminder',
    messageKey: 'notifications.invoice-payment-reminder-message',
    message: 'notifications.invoice-payment-reminder-message',
    type: NotificationType.REMINDER,
    priority: NotificationPriority.HIGH,
    status: NotificationStatus.DELIVERED,
    isRead: true,
    readDate: new Date('2024-01-16T08:15:00Z'),
    createdDate: new Date('2024-01-15T14:20:00Z'),
    relatedEntityType: RelatedEntityType.INVOICE,
    relatedEntityId: 1,
    actionUrl: '/invoices/1',
    actionTextKey: 'notifications.pay-now',
    actionText: 'notifications.pay-now',
    icon: 'credit-card',
    color: '#FF6B6B',
  },
  {
    id: 3,
    userId: 3,
    titleKey: 'notifications.booking-confirmed',
    title: 'notifications.booking-confirmed',
    messageKey: 'notifications.booking-confirmed-message',
    message: 'notifications.booking-confirmed-message',
    type: NotificationType.SUCCESS,
    priority: NotificationPriority.LOW,
    status: NotificationStatus.DELIVERED,
    isRead: false,
    createdDate: new Date('2024-01-10T10:00:00Z'),
    relatedEntityType: RelatedEntityType.BOOKING,
    relatedEntityId: 1,
    actionUrl: '/bookings/1',
    actionTextKey: 'notifications.view-details',
    actionText: 'notifications.view-details',
    icon: 'calendar-check',
    color: '#96CEB4',
  },
  {
    id: 4,
    userId: 4,
    titleKey: 'notifications.emergency-alert',
    title: 'notifications.emergency-alert',
    messageKey: 'notifications.emergency-alert-message',
    message: 'notifications.emergency-alert-message',
    type: NotificationType.ALERT,
    priority: NotificationPriority.URGENT,
    status: NotificationStatus.DELIVERED,
    isRead: false,
    createdDate: new Date('2024-01-18T19:45:00Z'),
    relatedEntityType: RelatedEntityType.ANNOUNCEMENT,
    relatedEntityId: 3,
    actionUrl: '/announcements/3',
    actionTextKey: 'notifications.read-more',
    actionText: 'notifications.read-more',
    icon: 'alert-triangle',
    color: '#FFEAA7',
  },
  {
    id: 5,
    userId: 5,
    titleKey: 'notifications.new-job-assignment',
    title: 'notifications.new-job-assignment',
    messageKey: 'notifications.new-job-assignment-message',
    message: 'notifications.new-job-assignment-message',
    type: NotificationType.INFO,
    priority: NotificationPriority.MEDIUM,
    status: NotificationStatus.DELIVERED,
    isRead: true,
    readDate: new Date('2024-01-15T11:00:00Z'),
    createdDate: new Date('2024-01-15T10:45:00Z'),
    relatedEntityType: RelatedEntityType.REQUEST,
    relatedEntityId: 1,
    actionUrl: '/requests/1',
    actionTextKey: 'notifications.view-job',
    actionText: 'notifications.view-job',
    icon: 'briefcase',
    color: '#45B7D1',
  },
  {
    id: 6,
    userId: 1,
    titleKey: 'notifications.system-maintenance',
    title: 'notifications.system-maintenance',
    messageKey: 'notifications.system-maintenance-message',
    message: 'notifications.system-maintenance-message',
    type: NotificationType.SYSTEM,
    priority: NotificationPriority.MEDIUM,
    status: NotificationStatus.DELIVERED,
    isRead: false,
    createdDate: new Date('2024-01-20T09:00:00Z'),
    actionUrl: '/announcements',
    actionTextKey: 'notifications.learn-more',
    actionText: 'notifications.learn-more',
    icon: 'settings',
    color: '#A8E6CF',
  },
  {
    id: 7,
    userId: 2,
    titleKey: 'notifications.pet-registration-expiring',
    title: 'notifications.pet-registration-expiring',
    messageKey: 'notifications.pet-registration-expiring-message',
    message: 'notifications.pet-registration-expiring-message',
    type: NotificationType.WARNING,
    priority: NotificationPriority.MEDIUM,
    status: NotificationStatus.DELIVERED,
    isRead: false,
    createdDate: new Date('2024-01-12T15:30:00Z'),
    relatedEntityType: RelatedEntityType.PET_REGISTRY,
    relatedEntityId: 2,
    actionUrl: '/pet-registry/2',
    actionTextKey: 'notifications.renew-now',
    actionText: 'notifications.renew-now',
    icon: 'heart',
    color: '#FFB6C1',
  },
  {
    id: 8,
    userId: 3,
    titleKey: 'notifications.welcome-to-sunset-gardens',
    title: 'notifications.welcome-to-sunset-gardens',
    messageKey: 'notifications.welcome-to-sunset-gardens-message',
    message: 'notifications.welcome-to-sunset-gardens-message',
    type: NotificationType.SUCCESS,
    priority: NotificationPriority.LOW,
    status: NotificationStatus.DELIVERED,
    isRead: true,
    readDate: new Date('2023-06-15T12:00:00Z'),
    createdDate: new Date('2023-06-15T10:00:00Z'),
    actionUrl: '/dashboard',
    actionTextKey: 'notifications.get-started',
    actionText: 'notifications.get-started',
    icon: 'home',
    color: '#87CEEB',
  },
];
